import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loadingSummary: false,
  loadingDetails: false,
  loadingAssociate: false,
  error: false,
  count: null,
  store: {},
  associates: [],
  selectedAssociateDetails: {},
  stylistAssociates: [],
  stylistAssociatesCount: null,
};

const formatAssociatesData = (state, payload) => {
  return state.associates?.length ? [...state.associates, ...payload.items] : payload.items;
};

const formatStylistAssociatesData = (state, payload) => {
  return state.stylistAssociates?.length ? [...state.stylistAssociates, ...payload.items] : payload.items;
};

const clientConnectsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.MANAGER_CLIENT_CONNECTS_LOADING:
      return {
        ...state,
        loadingSummary: true,
        error: false,
      };
    case actionTypes.MANAGER_CLIENT_CONNECTS_ERROR:
      return {
        ...state,
        loadingSummary: false,
        error: true,
      };
    case actionTypes.MANAGER_CLIENT_CONNECTS_SUCCESS:
      return {
        ...state,
        loadingSummary: false,
        store: { ...payload },
      };
    case actionTypes.MANAGER_CLIENT_CONNECTS_DETAILS_LOADING:
      return {
        ...state,
        loadingDetails: true,
        error: false,
      };
    case actionTypes.MANAGER_CLIENT_CONNECTS_DETAILS_ERROR:
      return {
        ...state,
        loadingDetails: false,
        error: true,
      };
    case actionTypes.MANAGER_CLIENT_CONNECTS_DETAILS_SUCCESS:
      return {
        ...state,
        loadingDetails: false,
        count: payload.count,
        associates: formatAssociatesData(state, payload),
      };
    case actionTypes.MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_LOADING:
    case actionTypes.STYLIST_MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_LOADING:
      return {
        ...state,
        loadingAssociate: true,
      };
    case actionTypes.MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_SUCCESS:
      return {
        ...state,
        loadingAssociate: false,
        selectedAssociateDetails: payload,
      };
    case actionTypes.STYLIST_MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_SUCCESS:
      return {
        ...state,
        loadingAssociate: false,
        selectedStylistManagerAssociateDetails: payload,
      };
    case actionTypes.STYLIST_MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_CLEAR:
      return {
        ...state,
        loadingAssociate: false,
        selectedStylistManagerAssociateDetails: {},
      };
    case actionTypes.MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_CLEAR:
      return {
        ...state,
        loadingAssociate: false,
        selectedAssociateDetails: {},
      };
    case actionTypes.MANAGER_CLIENT_CONNECTS_CLEAR:
      return {
        ...state,
        loadingSummary: false,
        loadingDetails: false,
        associates: {},
      };
    case actionTypes.STYLIST_MANAGER_CLIENT_CONNECTS_LOADING:
      return {
        ...state,
        loadingSummary: true,
        error: false,
      };
    case actionTypes.STYLIST_MANAGER_CLIENT_CONNECTS_ERROR:
      return {
        ...state,
        loadingSummary: false,
        error: true,
      };
    case actionTypes.STYLIST_MANAGER_CLIENT_CONNECTS_SUCCESS:
      return {
        ...state,
        loadingSummary: false,
        store: { ...payload },
      };
    case actionTypes.STYLIST_MANAGER_CLIENT_CONNECTS_DETAILS_LOADING:
      return {
        ...state,
        loadingDetails: true,
        error: false,
      };
    case actionTypes.STYLIST_MANAGER_CLIENT_CONNECTS_DETAILS_SUCCESS:
      return {
        ...state,
        loadingDetails: false,
        stylistAssociatesCount: payload.count,
        stylistAssociates: formatStylistAssociatesData(state, payload),
      };
    case actionTypes.STYLIST_MANAGER_CLIENT_CONNECTS_DETAILS_ERROR:
      return {
        ...state,
        loadingDetails: false,
        error: true,
      };
    case actionTypes.STYLIST_MANAGER_CLIENT_CONNECTS_DETAILS_CLEAR:
      return {
        ...state,
        stylistAssociatesCount: INITIAL_STATE.stylistAssociatesCount,
        stylistAssociates: INITIAL_STATE.stylistAssociates,
      };
    default:
      return state;
  }
};

export default clientConnectsReducer;
